import React, { useEffect, useState } from "react";
import { Box, Grid, Tabs, Tab } from "@material-ui/core";
import useStyles from "../Styles";
import { useSelector } from "react-redux";
import userActions from "../actions";
import { useHistory, useLocation } from "react-router";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

// Import Donut Charts
import IrrigationDonut from "./IrrigationDonut";
import CitiesDonut from "./CitiesDonut";

const IrrigationView = () => {
  const { setCentralAZTab } = userActions();
  const history = useHistory();
  const classes = useStyles();
  const { isMobile } = useGetViewPortDimensions();
  // const [tab, setTab] = React.useState("cities");
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tab = params.get('type');
  const dropdown = params.get('dropdown');
  const {
    loadWaterDeliveries,
    // loadCityMetrics,
    setSelectedCity,
    loadCityMetrics,
    setSelectedIrrigationDistrict,
    setIsTribe,
    setIsWesternEntity,
    setIsCity,
  } = userActions();

  const handleURLParamsChange = (label) => {
    if (
      central_az_tab === "irrigation_district" &&
      Object.keys(irrigation_districts).length > 0
    ) {
      var irrigationFound = irrigation_districts.find((item) => item.label.toLowerCase() === (dropdown.toLowerCase()));
      setSelectedIrrigationDistrict(irrigationFound); //the irrigation_districts array index is 1 below the irrigation_district value
      setIsCity(false)
      setIsTribe(false);
      setIsWesternEntity(true);
    } else if (
      central_az_tab === "cities" &&
      Object.keys(cities).length > 0
    ) {
      var cityFound = cities.find((item) => item.label.toLowerCase() === (dropdown?.toLowerCase() || 'Phoenix'));
      /** Don't Mutate the Redux state when the cityFound is null/undefined */
      if(cityFound) {
        setSelectedCity(cityFound);
        loadCityMetrics(cityFound.value);
        setIsCity(true)
        setIsTribe(false);
        setIsWesternEntity(false);
      }
    }
  }

  const componentMount = () => {
    loadWaterDeliveries();
  };
  useEffect(componentMount, []);
  const {
    irrigation_district_water_deliveries: district_deliveries1,
    city_metrics: city_metrics1,
    central_az_tab,
    city_selected,
    irrigation_district_selected,
    irrigation_districts,
    cities,
  } = useSelector((state) => state.technical_view);

  const handleTabs = () => {
    if(isMobile) {
      if (tab === "irrigation_district" || tab === "cities") {
        setCentralAZTab(tab)
      }
      handleURLParamsChange(dropdown)
    } 
  }
  useEffect(handleTabs, [isMobile, tab, dropdown, cities, irrigation_districts]);

  const onChangeTab = (event, value) => {
    // setTab(value);
    setCentralAZTab(value);
    //Updated path params on switching tabs
    if (value === "irrigation_district") {
      history.push({
        pathname: `/visualizations/doughnut`,
        search:
          "?" +
          new URLSearchParams({
            type: "irrigation_district",
            dropdown: irrigation_district_selected.name,
          }).toString(),
      });
    } else {
      history.push({
        pathname: `/visualizations/doughnut`,
        search:
          "?" +
          new URLSearchParams({
            type: "cities",
            dropdown: city_selected.name,
          }).toString(),
      });
    }
  };
  // const [district_deliveries, setDistrictDeliveries] = useState(null);
  const [, setCityMetrics] = useState(null);

  // useEffect(() => {
  //   if (Object.keys(district_deliveries1).length > 0) {
  //     setDistrictDeliveries(district_deliveries1);
  //     // if (loggedIn) {
  //     //   let param = new URLSearchParams(location.search);
  //     //   let tab = param.get("type");
  //     //   setTab(tab || "cities");
  //     //   setCentralAZTab(tab || "cities");

  //     // }
  //     setCentralAZTab("cities");
  //   }
  // }, [district_deliveries1]);

  // We cannot resetSelected city on unmount for mobiles because when bottom drawer is opened, the irrigation view unmounts,
  // resulting in the chart sidebar constantly resetting to phoenix.
  // therefor, we have to reset selected city only when the central az tabs are changed for mobile views.
  // useEffect(() => {
  //   return () => {
  //     // if (!isMobile) {
  //     //   resetSelectedCity();
  //     //   loadCityMetrics(1);
  //     //   resetSelectedAgriculture();
  //     // }
  //   };
  // }, []);

  // reset city and agriculture when toggle tabs in ring chart
  // useEffect(() => {
  //   // if (isMobile) {
  //   if (central_az_tab == "irrigation_district") {
  //     // resetSelectedCity();
  //     // loadCityMetrics(1);
  //   }
  //   // else if (central_az_tab == "cities") {
  //   //   resetSelectedAgriculture();
  //   // }
  //   // }
  // }, [central_az_tab]);

  useEffect(() => {
    if (Object.keys(city_metrics1).length > 0) {
      setCityMetrics(city_metrics1);
      // if (loggedIn) {
      //   let param = new URLSearchParams(location.search);
      //   let tab = param.get("type");
      //   setTab(tab || "cities");
      //   setCentralAZTab(tab || "cities");
      // }
      // setCentralAZTab("cities")
    }
  }, [city_metrics1]);

  return (
    <Box
      className={classes.irrigationContainer}
      // Use flex column, center items horizontally, take full height
      style={{ display: "flex", flexDirection: "column", alignItems: "center", height: "100%" }}
    >
      <Grid
        item
        xs={12}
        className={classes.tabs}
        style={{ marginTop: 0, zIndex: 1, width: 'auto' }} 
      >
        {
          <Tabs
            style={{ fontSize: "16px", marginTop: "16px" }}
            value={central_az_tab}
            onChange={onChangeTab}
            classes={{ root: classes.tabRoot, indicator: classes.tabIndicator }}
          >
            <Tab
              classes={{
                root: classes.tabInactive,
                selected: classes.tabActive,
              }}
              value="cities"
              label="Cities"
              className={classes.startingTab}
              style={{ fontSize: "16px", width: 126 }}
            ></Tab>
            <Tab
              style={{ fontSize: "16px" }}
              classes={{
                root: classes.tabInactive,
                selected: classes.tabActive,
              }}
              value="irrigation_district"
              label="Irrigation District"
              className={classes.endingTab}
            ></Tab>
          </Tabs>
        }
      </Grid>
      {/* This Box will grow and center the chart */}
      <Box
         style={{
            flexGrow: 1, // Take remaining vertical space
            width: '100%', // Take full width
            display: 'flex',
            alignItems: 'center', // Center chart vertically
            justifyContent: 'center', // Center chart horizontally
            padding: '16px 0' // Add some vertical padding if needed
         }}
      >
        {central_az_tab === "irrigation_district" &&
        district_deliveries1 != null ? (
          <IrrigationDonut district_deliveries={district_deliveries1} />
        ) : central_az_tab === "cities" && city_metrics1 != null ? (
          <CitiesDonut city_metrics={city_metrics1} />
        ) : null}
      </Box>
    </Box>
  );
};
export default IrrigationView;
